import { encodeAbiParameters } from "viem";
export var V4ActionType;
(function (V4ActionType) {
    V4ActionType[V4ActionType["INCREASE_LIQUIDITY"] = 0] = "INCREASE_LIQUIDITY";
    V4ActionType[V4ActionType["DECREASE_LIQUIDITY"] = 1] = "DECREASE_LIQUIDITY";
    V4ActionType[V4ActionType["MINT_POSITION"] = 2] = "MINT_POSITION";
    V4ActionType[V4ActionType["BURN_POSITION"] = 3] = "BURN_POSITION";
    V4ActionType[V4ActionType["INCREASE_LIQUIDITY_FROM_DELTAS"] = 4] = "INCREASE_LIQUIDITY_FROM_DELTAS";
    V4ActionType[V4ActionType["MINT_POSITION_FROM_DELTAS"] = 5] = "MINT_POSITION_FROM_DELTAS";
    V4ActionType[V4ActionType["SWAP_EXACT_IN_SINGLE"] = 6] = "SWAP_EXACT_IN_SINGLE";
    V4ActionType[V4ActionType["SWAP_EXACT_IN"] = 7] = "SWAP_EXACT_IN";
    V4ActionType[V4ActionType["SWAP_EXACT_OUT_SINGLE"] = 8] = "SWAP_EXACT_OUT_SINGLE";
    V4ActionType[V4ActionType["SWAP_EXACT_OUT"] = 9] = "SWAP_EXACT_OUT";
    V4ActionType[V4ActionType["SETTLE"] = 11] = "SETTLE";
    V4ActionType[V4ActionType["SETTLE_ALL"] = 12] = "SETTLE_ALL";
    V4ActionType[V4ActionType["TAKE"] = 14] = "TAKE";
    V4ActionType[V4ActionType["TAKE_ALL"] = 15] = "TAKE_ALL";
    V4ActionType[V4ActionType["TAKE_PORTION"] = 16] = "TAKE_PORTION";
    V4ActionType[V4ActionType["CLOSE_CURRENCY"] = 18] = "CLOSE_CURRENCY";
    V4ActionType[V4ActionType["SWEEP"] = 20] = "SWEEP";
    V4ActionType[V4ActionType["WRAP"] = 21] = "WRAP";
    V4ActionType[V4ActionType["UNWRAP"] = 22] = "UNWRAP";
})(V4ActionType || (V4ActionType = {}));
const POOL_KEY_STRUCT = {
    name: "poolKey",
    type: "tuple",
    components: [
        { name: "currency0", type: "address" },
        { name: "currency1", type: "address" },
        { name: "fee", type: "uint24" },
        { name: "tickSpacing", type: "int24" },
        { name: "hooks", type: "address" },
    ],
};
const PATH_KEY_STRUCT = {
    name: "pathKey",
    type: "tuple",
    components: [
        { name: "intermediateCurrency", type: "address" },
        { name: "fee", type: "uint256" },
        { name: "tickSpacing", type: "int24" },
        { name: "hooks", type: "address" },
        { name: "hookData", type: "bytes" },
    ],
};
const ABI_DEFINITION = {
    [V4ActionType.INCREASE_LIQUIDITY]: [
        { type: "uint256" },
        { type: "uint256" },
        { type: "uint128" },
        { type: "uint128" },
        { type: "bytes" },
    ],
    [V4ActionType.DECREASE_LIQUIDITY]: [
        { type: "uint256" },
        { type: "uint256" },
        { type: "uint128" },
        { type: "uint128" },
        { type: "bytes" },
    ],
    [V4ActionType.MINT_POSITION]: [
        POOL_KEY_STRUCT,
        { type: "int24" },
        { type: "int24" },
        { type: "uint256" },
        { type: "uint128" },
        { type: "uint128" },
        { type: "address" },
        { type: "bytes" },
    ],
    [V4ActionType.BURN_POSITION]: [
        { type: "uint256" },
        { type: "uint128" },
        { type: "uint128" },
        { type: "bytes" },
    ],
    [V4ActionType.INCREASE_LIQUIDITY_FROM_DELTAS]: [
        { type: "uint256" },
        { type: "uint128" },
        { type: "uint128" },
        { type: "bytes" },
    ],
    [V4ActionType.MINT_POSITION_FROM_DELTAS]: [
        POOL_KEY_STRUCT,
        { type: "int24" },
        { type: "int24" },
        { type: "uint128" },
        { type: "uint128" },
        { type: "address" },
        { type: "bytes" },
    ],
    [V4ActionType.SWAP_EXACT_IN_SINGLE]: [
        {
            name: "swapParams",
            type: "tuple",
            components: [
                POOL_KEY_STRUCT,
                { name: "zeroForOne", type: "bool" },
                { name: "amountIn", type: "uint128" },
                { name: "amountOutMinimum", type: "uint128" },
                { name: "hookData", type: "bytes" },
            ],
        },
    ],
    [V4ActionType.SWAP_EXACT_IN]: [
        {
            name: "swapParams",
            type: "tuple",
            components: [
                { name: "currencyIn", type: "address" },
                {
                    name: "path",
                    type: "tuple[]",
                    components: PATH_KEY_STRUCT.components,
                },
                { name: "amountIn", type: "uint128" },
                { name: "amountOutMinimum", type: "uint128" },
            ],
        },
    ],
    [V4ActionType.SWAP_EXACT_OUT_SINGLE]: [
        {
            name: "swapParams",
            type: "tuple",
            components: [
                POOL_KEY_STRUCT,
                { name: "zeroForOne", type: "bool" },
                { name: "amountOut", type: "uint128" },
                { name: "amountInMaximum", type: "uint128" },
                { name: "hookData", type: "bytes" },
            ],
        },
    ],
    [V4ActionType.SWAP_EXACT_OUT]: [
        {
            name: "swapParams",
            type: "tuple",
            components: [
                { name: "currencyOut", type: "address" },
                {
                    name: "path",
                    type: "tuple[]",
                    components: PATH_KEY_STRUCT.components,
                },
                { name: "amountOut", type: "uint128" },
                { name: "amountInMaximum", type: "uint128" },
            ],
        },
    ],
    [V4ActionType.SETTLE]: [
        { type: "address" },
        { type: "uint256" },
        { type: "bool" },
    ],
    [V4ActionType.SETTLE_ALL]: [{ type: "address" }, { type: "uint256" }],
    [V4ActionType.TAKE]: [
        { type: "address" },
        { type: "address" },
        { type: "uint256" },
    ],
    [V4ActionType.TAKE_ALL]: [{ type: "address" }, { type: "uint256" }],
    [V4ActionType.TAKE_PORTION]: [
        { type: "address" },
        { type: "address" },
        { type: "uint256" },
    ],
    [V4ActionType.CLOSE_CURRENCY]: [{ type: "address" }],
    [V4ActionType.SWEEP]: [{ type: "address" }, { type: "address" }],
    [V4ActionType.WRAP]: [{ type: "uint256" }],
    [V4ActionType.UNWRAP]: [{ type: "uint256" }],
};
export class V4ActionBuilder {
    constructor() {
        this.actions = "0x";
        this.inputs = [];
    }
    addAction(type, parameters) {
        const encoded = encodeAbiParameters(ABI_DEFINITION[type], parameters);
        this.actions += type.toString(16).padStart(2, "0");
        this.inputs.push(encoded);
        return this;
    }
    addSwapExactInSingle(poolKey, zeroForOne, amountIn, amountOutMinimum, hookData) {
        return this.addAction(V4ActionType.SWAP_EXACT_IN_SINGLE, [
            {
                poolKey,
                zeroForOne,
                amountIn,
                amountOutMinimum,
                hookData,
            },
        ]);
    }
    addSwapExactOutSingle(poolKey, zeroForOne, amountOut, amountInMaximum, hookData) {
        return this.addAction(V4ActionType.SWAP_EXACT_OUT_SINGLE, [
            {
                poolKey,
                zeroForOne,
                amountOut,
                amountInMaximum,
                hookData,
            },
        ]);
    }
    addWrap(amount) {
        return this.addAction(V4ActionType.WRAP, [amount]);
    }
    addUnwrap(amount) {
        return this.addAction(V4ActionType.UNWRAP, [amount]);
    }
    build() {
        return [this.actions, this.inputs];
    }
}
//# sourceMappingURL=V4ActionBuilder.js.map